



















import { CommonField } from '@ssp/inscreva-sse-models';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {
    DynamicInfo: () => import('./DynamicInfo.vue'),
  },
})
export default class DynamicInfoComponent extends Vue {
  @Prop({ required: true })
  arr_info: CommonField | Record<string, any>;

  @Prop()
  title?: string;

  isCommonField(field: Record<string, any>): boolean {
    return !!(field as CommonField).label;
  }
}
